<template>
  <div class="flex">
    <div class="w-[50px] mr-3 text-right">
      {{ rank }}:
    </div>
    <div class="w-[210px] mr-6">
      <UserNameplate :username="displayName" />
    </div>
    <div>
      {{ arena_submode_data.elo_rating }}
    </div>
  </div>
</template>

<script setup>
import { UserNameplate } from '~/view/components/common/DOM';

const props = defineProps({
  displayName: {
    type: String,
    default: 'Anonymous',
  },
  arena_submode_data: {
    type: Object,
    required: true,
  },
  rank: {
    type: Number,
    required: true,
  }
});
</script>
